export default __webpack_public_path__ + "static/media/business_coverage.546d53c2.webp";